module.exports = __webpack_public_path__ + "img/star.3d1433f5.svg";